import { render, staticRenderFns } from "./MainSite.vue?vue&type=template&id=19f19730&"
import script from "./MainSite.vue?vue&type=script&lang=js&"
export * from "./MainSite.vue?vue&type=script&lang=js&"
import style0 from "./MainSite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports